import {
  getUser,
  getColumns,
} from '@/api/app';

export default {
  namespaced: true,
  state: {
    navId: '0',
    listId: 0,
    columns: [],
    navIndex: 0,
    userInfo: {},
    classList: [],
    classifyIndex: 0,
    menuOpenId: 0,
  },
  mutations: {
    setNavId: (state, id) => {
      state.navId = id;
    },
    setListId: (state, id) => {
      state.listId = id;
    },
    setClassifyIndex: (state, index) => {
      state.classifyIndex = Number(index);
    },
    setUserInfo: (state, userInfo) => {
      state.userInfo = userInfo;
    },
    setClassList: (state, classList) => {
      state.classList = classList;
    },
    setColumns: (state, columns) => {
      state.columns = columns;
    },
    setNavIndex: (state, index) => {
      state.navIndex = Number(index);
    },
    setMenuOpenId: (state, id) => {
      state.menuOpenId = id;
    },
  },
  actions: {
    // 用户信息
    async getUserInfo({ commit }) {
      const { data } = await getUser();
      commit('setUserInfo', data || {});
      return data;
    },

    // 栏目列表
    async getColumns({ commit }) {
      const { data } = await getColumns();
      commit('setColumns', data || []);
      return data || [];
    },

  },
};
